export default "__VITE_ASSET__c907f3d3__"